import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { StepActionTypeSchema } from '../../shared/step-action-type.schema';
import { AssigneeModelSchema } from '../../shared/assignee-model.schema';
// --- Create Skeleton Step ---
export const CreateSkeletonStepRequestSchema = z.object({
    actionType: StepActionTypeSchema,
    assignedTo: ObjectIdSchema.optional(),
    assignedToModel: AssigneeModelSchema.optional()
});
export const CreateSkeletonStepResponseSchema = z.object({
    step: z.object({
        _id: z.string(),
        actionType: StepActionTypeSchema,
        assignedTo: z.string().optional(),
        assignedToModel: AssigneeModelSchema.optional()
    })
});
// --- Insert Step on Edge ---
export const InsertStepRequestSchema = z.object({
    actionType: StepActionTypeSchema,
    upstreamStepId: ObjectIdSchema,
    downstreamStepId: ObjectIdSchema,
    sourceRuleId: ObjectIdSchema.optional()
});
export const InsertStepResponseSchema = z.object({
    step: z.object({
        _id: z.string(),
        actionType: StepActionTypeSchema,
        previousStep: z.string()
    })
});
// --- Connect Steps ---
export const ConnectStepsRequestSchema = z.object({
    sourceStepId: ObjectIdSchema,
    targetStepId: ObjectIdSchema,
    sourceRuleId: ObjectIdSchema.optional()
});
export const ConnectStepsResponseSchema = z.object({
    updated: z.boolean()
});
// --- Disconnect Steps ---
export const DisconnectStepsRequestSchema = z.object({
    sourceStepId: ObjectIdSchema,
    targetStepId: ObjectIdSchema,
    sourceRuleId: ObjectIdSchema.optional(),
    /**
   * Draft editor only: scope removal to a single decision output. When set,
   * only the rules sharing this rule's output (one handle/edge) are unbound
   * from the target — other outputs of the same decision (and fan-in siblings)
   * survive. Absent → the whole connection from the source is removed.
   */ ruleId: ObjectIdSchema.optional()
});
export const DisconnectStepsResponseSchema = z.object({
    updated: z.boolean()
});
// --- Update Flow Positions ---
export const FlowPositionItemSchema = z.object({
    stepId: z.string(),
    x: z.number(),
    y: z.number()
});
export const UpdateFlowPositionsRequestSchema = z.object({
    positions: z.array(FlowPositionItemSchema).max(500)
});
export const UpdateFlowPositionsResponseSchema = z.object({
    updated: z.number()
});
// --- Get Flow Positions ---
export const GetFlowPositionsResponseSchema = z.object({
    positions: z.array(FlowPositionItemSchema)
});
// --- Send Flow Invitations ---
export const FlowInvitationItemSchema = z.object({
    stepId: ObjectIdSchema
});
export const SendFlowInvitationsRequestSchema = z.object({
    invitations: z.array(FlowInvitationItemSchema).min(1).max(100)
});
export const SendFlowInvitationsResponseSchema = z.object({
    sent: z.number()
});
// --- Assign Step (set assignedTo on skeleton) ---
export const AssignFlowStepRequestSchema = z.object({
    assignedTo: ObjectIdSchema,
    assignedToModel: AssigneeModelSchema
});
export const AssignFlowStepResponseSchema = z.object({
    updated: z.boolean()
});

//# sourceMappingURL=process-flow-editor.schema.js.map